










































































































import {Emit} from "vue-property-decorator";
import {InOut} from 'vue-inout-prop-decorator';
import {Component} from '@/shared/component';
import {AbstractEditVue} from '@/components/Abstract/AbstractEditVue';
import {Achat} from '@/models';

import storeAchat from '@/stores/modules/achat';
import storeFournisseur from '@/stores/modules/fournisseur';

import CrudTransporteurSearch from "@/components/Crud/Transporteur/Search.vue";
import CrudFournisseurSearch from "@/components/Crud/Fournisseur/Search.vue";
import CrudLongueursAchatSearch from "@/components/Crud/LongueursAchat/Search.vue";
import CrudBoisTypeSearch from "@/components/Crud/BoisType/Search.vue";
import InputBoisType from "@/components/Input/BoisType.vue";
import InputLongueursAchat from "@/components/Input/LongueursAchat.vue";
import InputDatePicker from "@/components/Input/DatePicker.vue";
import storeVente from "@/stores/modules/vente";

@Component({
	components: {
		CrudTransporteurSearch,
		CrudFournisseurSearch,
		CrudLongueursAchatSearch,
		CrudBoisTypeSearch,
		InputBoisType,
		InputLongueursAchat,
		InputDatePicker,
	}
})
export default class CrudAchatEdit extends AbstractEditVue<Achat> {

	// DF: utiliser pour la création d'un achat uniquement
	// en modification on passe par la light
	private step: number = 1;
	private savedisabled: Boolean = true;

	private storeFournisseur = storeFournisseur

	public constructor() {
		super(
			storeAchat,
			'Achat modifié',
			'Achat créé',
		);
	}

	public watcher(): void {
		if (this.item)
		{
			if (!this.item.fournisseur)
			{
				this.savedisabled = true;
			}
			else
			{
				this.savedisabled = false;
			}
		}
	}

//	@Emit()
//	private onNext() {
//		if ((!this.item.address) || (this.item.address === null) )
//		{
//			this.item.address = this.item.name;
//		}
//		this.step = 2;
//	}

	protected async onSubmit(): Promise<void> {
		super.onSubmit();
		this.step = 1;
	}

	public async mounted(): Promise<void> {
		await storeFournisseur.dispatch('getAll');
		await super.mounted();
	}

	public async refresh(): Promise<void> {
		await super.refresh();
		this.watcher();
		//console.log('route achat edit = ' + this.$route.name);
		if (this.$route.name === 'achat-edit') {
			this.$route.meta.title = 'Modification  d\'un achat';
		}
	}

}
